

var SELECTOR_PREFIX_REGEXP = /^[a-z0-9_-]*$/gi;


export default function getRehydrationIndex(renderer) {
  if (renderer.selectorPrefix.length === 0 || renderer.selectorPrefix.match(SELECTOR_PREFIX_REGEXP) !== null) {
    return renderer.uniqueRuleIdentifier;
  }

  return -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/server/getRehydrationIndex.js
// module id = 583
// module chunks = 1